import request from "@/utils/request";

export function getChannelList() {
  return request({ url: "/user/recharge/channel/list", method: "post" });
}

export function createOrder(data) {
  return request({ url: "/user/recharge/create", method: "post", data: data });
}
